export default {
  "overlay": "_overlay_1yqrmn"
};